export default {
  accentColor: '#448AFF',
  floatingNav: {
    background: '',
    chevron: '',
    color: ''
  },
  headerColor: '',
  selectionColor: '',
  textColor: {
    active: '',
    default: ''
  },
  todayColor: '',
  weekdayColor: ''
}
